import React from 'react';
import { GenericFilterHeader } from './GenericFilterHeader';
import { PRICE_CHANGE_SCOPE_LABELS } from '../../../../helpers/priceChangeScope';

const SCOPE_OPTIONS = [
    'All',
    PRICE_CHANGE_SCOPE_LABELS.STORE,
    PRICE_CHANGE_SCOPE_LABELS.SPECIFIC_STORES,
    PRICE_CHANGE_SCOPE_LABELS.ZONE,
];

interface ScopeColumnHeaderProps {
    readonly currentValue: string[] | null;
    readonly onChange: (value: string[] | null) => void;
}

export function ScopeHeader({
    currentValue,
    onChange,
}: ScopeColumnHeaderProps) {
    return (
        <GenericFilterHeader
            label="Scope"
            filterOptions={SCOPE_OPTIONS}
            currentValue={currentValue}
            onChange={onChange}
        />
    );
}

ScopeHeader.displayName = 'ScopeHeader';
